module.exports = __webpack_public_path__ + "img/services-icon-3.734be582.png";